export const EMPTY_ARRAY = [];

export const fallbackToEmptyArray = array =>
  !array || array.length === 0 ? EMPTY_ARRAY : array;
